import { render, staticRenderFns } from "./hcd-more-buttom.vue?vue&type=template&id=3b87d5a8&scoped=true"
import script from "./hcd-more-buttom.vue?vue&type=script&lang=js"
export * from "./hcd-more-buttom.vue?vue&type=script&lang=js"
import style0 from "./hcd-more-buttom.vue?vue&type=style&index=0&id=3b87d5a8&prod&lang=less&scoped=true"
import style1 from "./hcd-more-buttom.vue?vue&type=style&index=1&id=3b87d5a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b87d5a8",
  null
  
)

export default component.exports